import type { FunctionComponent } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { RapsInfoAlert } from './RapsInfoAlert';

const CallToAction = styled.div`
  text-transform: uppercase;
`;

export const AnonymousUserNotice: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Link to="/login">
      <RapsInfoAlert
        message={t('anonymousUserNotice.notice')}
        description={
          <CallToAction>{t('anonymousUserNotice.callToAction')}</CallToAction>
        }
      />
    </Link>
  );
};
